<template>
  <div>
    <div v-if="status == 'pending'" class="flex justify-center w-full p-3">
      <LoadingSpinner  size="lg" />
    </div>
    <SpotDetails v-if="spot" :spot="spot" />
    <SoMeSharing v-if="spot" :spot="spot" />
    <Tags v-if="spot && auth.user.value?.premium" :spot="spot" :user="auth.user" />
    <CommentList
      v-if="spot"
      :spot="spot"
      class="my-2 px-1 sm:px-0"
    />
    <SpotDetailsReport v-if="spot && auth.authenticated.value && !spot.userData?.spotAuthor" :spot="spot"
                       :reported="spot.userData?.reported" />
    <ErrorView v-if="error" :error="error" @retry="refresh" :status="status" />
  </div>
</template>
<script setup lang="ts">

import SoMeSharing from '~/components/Spot/SoMeSharing.vue';

const auth = useAuth();
const platform = usePlatformSettings().platformName;
const props = defineProps<{ id?: String, oldId?: String }>();

const spotOrEntry = props.id ? 'spots' : 'entries';
const authenticated = auth.authenticated.value;

const id = props.id ? props.id : props.oldId;

const {
  data: spot,
  error,
  refresh,
  status
} = auth.authenticated.value ? await useApiAuth().asyncData<SpotDetail>(spotOrEntry + '/' + id) : await useApi().asyncData<SpotDetail>(spotOrEntry + '/' + id);

if (spot.value) {
  setSeoMetaData(spot.value);
}

function setSeoMetaData(spot: SpotDetail) {
  useSeoMeta({
    title: platform.value + ' – ' + spot.title,
    ogTitle: platform.value + ' – ' + spot.title,
    description: spot.text,
    ogDescription: spot.text,
    ogImage: useImageUrl(spot.gallery[0].imageId, 'large'),
    twitterImage: useImageUrl(spot.gallery[0].imageId, 'large'),
    twitterCard: 'summary_large_image'
  });
}

</script>
